import * as Logger from "js-logger";
import "pixi.js";
import FooterComponent from "slotworks/components/info/footer-component";
import GameLoop from "slotworks/core/game-loop";
import ButtonElement from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { MultiStyleText } from "slotworks/graphics/pixi/pixi-multistyle-text";
import RevolverBuilders from "slotworks/integration/revolver/revolver-builders";
import { RevolverInit, RevolverReady} from "slotworks/integration/revolver/revolver-setup";
import BuilderManager from "slotworks/server/builders/builder-manager";
import SlotWorks from "slotworks/slotworks";
import HiddenButtonBehaviour from "slotworks/smart-button/behaviours/hidden-button-behaviour";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import SymbolCelebration from "slotworks/state-machine/standard/states/symbol-celebration";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import { EnableOnScreenErrors } from "slotworks/utils/debug";
import POTCRecoveryRecordBuilder from "./integration/revolver/potc-recovery-record-builder";
import ICInit from "./states/ic-init";
import BannerComponent from "slotworks/components/banner/banner-component";
import CanvasManager,{Orientation} from "slotworks/graphics/canvas/canvas-manager";
import { setTimeout } from "timers";
import deviceInfo from "slotworks/utils/device-info";
import FreespinsTriggeredDecission from "decisions/freespins-triggered";
import FreespinsRetriggeredDecission from "decisions/freespins-retriggered";
import ICRetriggerFreespins from "states/ic-retrigger-freespins";
import SpinRecordBuilder from "slotworks/integration/revolver/builders/records/spin-record-builder";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import LoopWinsDecision from "decisions/loop-wins-decision";
import DSReelSpinner from "components/matrix/transition/reel-spinner";
import Components from "slotworks/components/components";
import graphicsManager from "slotworks/graphics/graphics-manager";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import gameState from "slotworks/model/game-state";
import ShowWinLines from "slotworks/state-machine/standard/states/show-win-lines";
import Spin from "slotworks/state-machine/standard/states/spin";
import FreespinIdle from "slotworks/state-machine/standard/states/freespin-idle";
import ICRecordBuilder from "integration/revolver/ic-record-builder";
import CoinsDrop from "states/coins-drop";
import HasCoinsDecision from "decisions/has-coins";
import ICExitFreespins from "states/ic-exit-freespin";
import PotsTriggeredDecision from "decisions/pots-triggered";
import PotsAction from "states/pots-action";
import ICEnterFreespins from "states/ic-enter-freespins";
import ICEnterRecoveryFreespins from "states/ic-enter-recovery-freespins";
import IsBonusTriggered from "slotworks/state-machine/standard/decisions/is-bonus-triggered";
import ICBonusRecordBuilder from "integration/revolver/ic-bonus-record-builder";
import IcPaytableRecordBuilder from "integration/revolver/ic-paytable-record-builder";
import ICBonus from "states/ic-bonus";
import BonusResultBuilder from "integration/revolver/bonus-result-builder";
import BonusWin from "states/bonus-win";
import EnterFreespinsTransition from "transitions/enter-freespins-transitions";
import BigWinTransitions from "transitions/big-win-transitions";
import BigWinComponent from "slotworks/components/bigwin/big-win-component";
import MegaWinTransitions from "transitions/mega-win-transitions";
import SuperMegaWinTransitions from "transitions/super-mega-win-transitions";
import EpicWinTransitions from "transitions/epic-win-transitions";
import IsJackpotDecision from "decisions/is-jackpot";
import Jackpot from "states/jackpot";
import ICBigWins from "states/ic-big-wins";
import JackpotIntroTransitions from "transitions/jackpot-intro-transitions";
import JackpotEndTransitions from "transitions/jackpot-end-transitions";
import FreespinsBigWinTransitions from "transitions/freespins-big-win-transitions";
import FreespinsMegaWinTransitions from "transitions/freespins-mega-win-transitions";
import FreespinsSuperMegaWinTransitions from "transitions/freespins-super-mega-win-transitions";
import FreespinsEpicWinTransitions from "transitions/freespins-epic-win-transitions";
import PromptComponent from "slotworks/components/prompt/prompt-component";
import BonusWheel2Transitions from "transitions/bonuswheel2-transitions";
import BonusWheel3Transitions from "transitions/bonuswheel3-transitions";
import BonusTransitions from "transitions/bonus-transitions";
import FreespinsActive from "decisions/freespins-active";
import BonusWinTransitions from "transitions/bonus-win-transitions";
import LineWinTransitions from "transitions/lines-win-transitions";
import EnterRecoveryBonus from "states/enter-recovery-bonus";
import PotWinTransitions from "transitions/pot-win-transitions";
import IsBonusRecoveryTriggered from "decisions/is-bonus-recovery-triggered";
import ICShowWinLines from "states/show-win-lines";
import JackpotCelebration from "states/jackpot-celebration";
import { LayoutMapSchema } from "slotworks/config/game-config-schema";
import FreespinButtonBehaviour from "slotworks/smart-button/behaviours/freespin-button-behaviour";
import ICIdle from "states/ic-idle";
import State from "slotworks/state-machine/states/state";
import BetBarResizer from "slotworks/components/betbar/bet-bar-resizer";
import soundManager from "slotworks/sound/sound-manager";
import ICAutoplay from "states/ic-autoplay";
import ICLoopWins from "states/ic-loop-wins";

declare const __DEBUG__: boolean;
declare const require: any;
const assetConfig = require("./asset-config.json");
const gameConfig = require("./game-config.json");
const stateConfig = require("./state-config.json");
const soundConfig = require("./sound-config.json");
const componentConfig = require("./component-config.json");
const i18nConfig = require("./i18n-config.json");

require("../static/styles.scss");

if (__DEBUG__) {
    Logger.useDefaults();
}

// enable frame skipping so the game dont become faster after pauses
(<any>GameLoop).frameSkipping = true;

RevolverInit();

const ready = () => {
    if (__DEBUG__) {
        (<any>window).Layers = Layers;
        (<any>window).Components = Components;
        (<any>window).deviceInfo = deviceInfo;
        (<any>window).graphics = graphicsManager;
        (<any>window).campaignsModel = campaignsModel;
        (<any>window).gameState = gameState;
        (<any>window).smart = SmartButton;
    }

    setupTransitions();

    MultiStyleText.autoShrink = true;
    MultiStyleText.debugOptions.autoShrink.enabled = true;

    if (__DEBUG__) {
        GameLoop.showStats();
    }
    BetBarResizer.MOBILE_TEXTS_SCALE = true;
    RevolverReady();

    BannerComponent.loopTime = 1000000;
    ShowWinLines.MULTILINE_ONLY = false;
    FreespinButtonBehaviour.HIDDEN = false;
    soundManager.MUSIC_LAYERS = true;
    Layers.Custom.get("Torches").alwaysResetOnOrientationChange = true;
    
    for (let mask = 0; mask < SmartButtonFlag.MAX; mask++) {
        // Revolver does not have a stop auto spin button during freespins
        if ((mask & SmartButtonFlag.BONUS) > 0) {
            SmartButton.overrideBehaviour(mask, HiddenButtonBehaviour);
        }
    }

    DSReelSpinner.anticipationLayer = Layers.Custom.get("Anticipation");
    DSReelSpinner.minRepeats = 25;
    FooterComponent.layer = Layers.MatrixForeground;

    ButtonElement.DISABLED_TINT = 0xA9A9A9;
    ButtonElement.OVER_TINT = 0xd3d3d3;
    ButtonElement.DOWN_SCALE = 0.8;
};


const setupComms = () => {
    revolverModel.addFreespinIdentifiers(["FREE_SPINS"]);
    RevolverBuilders.init();
    BuilderManager.removeRecordBuilder(SpinRecordBuilder);
    BuilderManager.addRecordBuilder(ICRecordBuilder);
    BuilderManager.addRecordBuilder(POTCRecoveryRecordBuilder);
    BuilderManager.addRecordBuilder(ICBonusRecordBuilder);
    BuilderManager.addRecordBuilder(IcPaytableRecordBuilder);
    BuilderManager.addResultBuilder(BonusResultBuilder);
};

const setupStates = () => {

    StateRegister.add("potc-init", new ICInit(StateMachine));

    // Freespins
    StateRegister.add("potc-enter-freespins", new ICEnterFreespins(StateMachine));

    StateRegister.add('show-win-lines-boxes', new ICShowWinLines(StateMachine));
    StateRegister.add('ds-freespin-idle', new FreespinIdle(StateMachine));
    StateRegister.add('freespins-retrigger', new ICRetriggerFreespins(StateMachine));
    StateRegister.add("ds-enter-recovery-freespins", new ICEnterRecoveryFreespins(StateMachine));
    StateRegister.add("bonus-wheel-recovery", new EnterRecoveryBonus(StateMachine)),
    StateRegister.add("ds-exit-freespins", new ICExitFreespins(StateMachine));
    StateRegister.add("ds-spin", new Spin(StateMachine));
    StateRegister.add("coins-drop", new CoinsDrop(StateMachine));
    StateRegister.add("pots-action", new PotsAction(StateMachine));
    StateRegister.add("bonus-wheel", new ICBonus(StateMachine));
    StateRegister.add("bonus-win", new BonusWin(StateMachine));
    StateRegister.add("jackpot", new Jackpot(StateMachine));
    StateRegister.add("ic-big-wins", new ICBigWins(StateMachine));
    StateRegister.add("ic-idle", new ICIdle(StateMachine));
    StateRegister.add("ic-autoplay", new ICAutoplay(StateMachine));
    StateRegister.add("ic-loop-wins", new ICLoopWins(StateMachine));

    //decisions
    StateRegister.add("ds-freespins-triggered", new FreespinsTriggeredDecission());
    StateRegister.add("freespins-retriggered-check", new FreespinsRetriggeredDecission());
    StateRegister.add("should-loop-wins", new LoopWinsDecision());
    StateRegister.add("has-coins", new HasCoinsDecision());
    StateRegister.add("pots-triggered", new PotsTriggeredDecision());
    StateRegister.add("is-jackpot-won", new IsJackpotDecision());
    StateRegister.add("ic-in-freespins", new FreespinsActive());
    
    StateRegister.add("bonus-wheel-check", new IsBonusTriggered("BONUS"));
    StateRegister.add("bonus-wheel-recovery-check", new IsBonusRecoveryTriggered("BONUS"));


    // Celebrations, todo text resource
    StateRegister.add("jackpot-celebration", new JackpotCelebration(StateMachine)); 
};

const setupTransitions = () => {
    BigWinComponent.CLICK_TO_SKIP = true;
    PromptComponent.DEFAULT_TIME = 800;

    for (let row = 1; row <= 4; row++) {
        if (Layers.CelebrationContent.hasScene(`line_row_${row}_win`)) {
            Layers.CelebrationContent.setTransitions(`line_row_${row}_win`, new LineWinTransitions());
        }
    }
    if (Layers.CelebrationContent.hasScene("totalWin")) {
        Layers.CelebrationContent.setTransitions("totalWin", new LineWinTransitions());
    }
    
    Layers.Prompts.setTransitions("freespinswin", new EnterFreespinsTransition());
    Layers.Prompts.setTransitions("freespinsretrigger", new EnterFreespinsTransition());
    Layers.Prompts.setTransitions("freespinssummary", new EnterFreespinsTransition());
    Layers.Prompts.setTransitions("freespinsnowin", new EnterFreespinsTransition());

    Layers.CelebrationContent.setTransitions("potWin", new PotWinTransitions());

    Layers.Prompts.setTransitions("bonuswheel2", new BonusWheel3Transitions());
    Layers.Prompts.setTransitions("bonuswheel3", new BonusWheel3Transitions());
    Layers.BonusForeground.setTransitions("BonusWheel", new BonusTransitions());
    
    const transitions = [new BigWinTransitions(), new MegaWinTransitions(), new SuperMegaWinTransitions(), new EpicWinTransitions()];

    Layers.CelebrationContent.setTransitions("bigWin", transitions[0]);
    Layers.CelebrationContent.setTransitions("megaWin", transitions[1]);
    Layers.CelebrationContent.setTransitions("superMegaWin", transitions[2]);
    Layers.CelebrationContent.setTransitions("epicWin", transitions[3]);

    Layers.CelebrationContent.setTransitions("bonusWin", new BonusWinTransitions());

    const freespinTransitions = [ new FreespinsBigWinTransitions(), new FreespinsMegaWinTransitions(), new FreespinsSuperMegaWinTransitions(), new FreespinsEpicWinTransitions()];

    Layers.CelebrationContent.setTransitions("freespins_bigWin", freespinTransitions[0]);
    Layers.CelebrationContent.setTransitions("freespins_megaWin", freespinTransitions[1]);
    Layers.CelebrationContent.setTransitions("freespins_superMegaWin", freespinTransitions[2]);
    Layers.CelebrationContent.setTransitions("freespins_epicWin", freespinTransitions[3]);

    Layers.CelebrationContent.setTransitions("jackpot_intro", new JackpotIntroTransitions());
    Layers.CelebrationContent.setTransitions("jackpot", new JackpotEndTransitions());
};

setupComms();
setupStates();

SlotWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, ready);

if (__DEBUG__) {
    EnableOnScreenErrors();
}
